<script setup>
import { navigateTo } from '#app'

navigateTo('/')
</script>

<template>
  <div />
</template>
